import { InjectionToken } from '@angular/core';

export interface IStorage {
  storeItem(key: string, item: string): Promise<void>;
  retrieveItem(key: string): Promise<string | null>;
}

export const IStorageToken = new InjectionToken<IStorage>('IStorage');
